module.exports = __webpack_public_path__ + "static/media/projectsImage10.597d13c7.jpg";